/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::21ae373abad7c370a8682ddcd3a7ed21>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-datasource
 */
import { useCallback } from 'react';
import { useAnalyticsEvents as useAnalyticsNextEvents } from '@atlaskit/analytics-next';
import { EVENT_CHANNEL } from '../constants';
import createEventPayload from './create-event-payload';
export var useAnalyticsEvents = function useAnalyticsEvents() {
  var _useAnalyticsNextEven = useAnalyticsNextEvents(),
    createAnalyticsEvent = _useAnalyticsNextEven.createAnalyticsEvent;
  var fireEvent = useCallback(function () {
    var event = createAnalyticsEvent(createEventPayload.apply(void 0, arguments));
    event.fire(EVENT_CHANNEL);
  }, [createAnalyticsEvent]);
  return {
    fireEvent: fireEvent
  };
};